export default __webpack_public_path__ + "static/media/showmore.845b271c.svg";